import ExotelDriver from "./ExotelDriver";
import StubDriver from "./StubDriver";
import SoftphoneDriver, { requestMicrophone } from "./SoftphoneDriver";

/**
 * Softphone driver factory.
 *
 * One line decides which browser-calling backend runs, so adding a provider is a
 * map entry — the hook, the widget and the fallback path never learn a vendor
 * name. Mirrors `services/telephonyProviders/index.js` on the backend, which
 * makes the same trade for the same reason.
 *
 * The stub is opt-in via `REACT_APP_SOFTPHONE_STUB=true`, never a silent
 * fallback: a stub that quietly stood in for a broken Exotel connection would
 * look like a working softphone and place no calls at all.
 */
const DRIVERS = {
  exotel: ExotelDriver,
  stub: StubDriver,
};

export function createSoftphoneDriver(provider) {
  if (process.env.REACT_APP_SOFTPHONE_STUB === "true") return new StubDriver();
  const Driver = DRIVERS[String(provider || "").toLowerCase()];
  return Driver ? new Driver() : null;
}

export { SoftphoneDriver, StubDriver, ExotelDriver, requestMicrophone };
